import routerOptions0 from "/Users/laurentlang/Documents/Websites/Online/Patchbox/pb-rack-planner-v3/frontend/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}